import { api } from "../../gateways/unilabApi";

export async function getPlatePricesWeightList() {
  return await api.get(`prices/plates/pricesWeightList`);
}

export async function getBrazedPricesWeightList() {
  return await api.get(`prices/brazed/pricesWeightList`);
}

export async function getPlatePricesWeightExportList() {
  return await api.get(`prices/plates/pricesWeightExportList`);
}

export async function getBrazedPricesWeightExportList() {
  return await api.get(`prices/brazed/pricesWeightExportList`);
}

export async function postUpdateAddAllExport_Plate(payload) {
  return await api.post(`prices/plates/updateAddAllExport`, payload);
}
export async function postUpdateAddAllExport_Brazed(payload) {
  return await api.post(`prices/brazed/updateAddAllExport`, payload);
}
export async function getPressuresGuidByGeomGuid(payload) {
  return await api.get(`prices/pressures/getPressuresGuidByGeomGuid?geomGuid=` + payload);
}
export async function getFramesPricesWeightList() {
  return await api.get(`prices/frames/pricesWeightList`);
}
export async function getFramesPricesWeightExportList() {
  return await api.get(`prices/frames/pricesWeightExportList`);
}
export async function postUpdateAddAllExport_Frame(payload) {
  return await api.post(`prices/frames/updateAddAllExport`, payload);
}
export async function getGasketsPricesWeightList() {
  return await api.get(`prices/gaskets/pricesWeightList`);
}
export async function getGasketsPricesWeightExportList() {
  return await api.get(`prices/gaskets/pricesWeightExportList`);
}
export async function postUpdateAddAllExport_Gasket(payload) {
  return await api.post(`prices/gaskets/updateAddAllExport`, payload);
}
export async function getExportModelPlates() {
  return await api.get(`prices/plates/exportModel`);
}
export async function getExportModelBrazed() {
  return await api.get(`prices/brazed/exportModel`);
}
export async function getExportModelFrames() {
  return await api.get(`prices/frames/exportModel`);
}
export async function getExportModelGaskets() {
  return await api.get(`prices/gaskets/exportModel`);
}
